import React, { useEffect, useState } from 'react';
import { getFromLocalStorage } from '../../components/helper/authorizationHelper';
import { postAsync } from '../../components/helper/axiosHelper';
import LogsTable from './LogsTable';
import { toast } from 'react-toastify';
import { t } from 'i18next';

const UserLogs = () => {
  const [loginLogs, setLoginLogs] = useState([]);
  const [epUserID, setEpUserID] = useState(null);
  const [pageCount, setPageCount] = useState(1);
  const [isload, setIsload] = useState(false);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20,
  });
  const [next, setNext] = useState(1);

  useEffect(() => {
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
    if (epUserID !== null) {
      getUserLogs();
    }
  }, [epUserID]);

  const getUserLogs = async () => {
    setIsload(true);
    const response = await postAsync(
      `EP_UserAuthentication/EPUserLoginLogsGetByID?page=${pageOptions.pageNo}&pageSize=${pageOptions.pageSize}`,
      { epUserID: epUserID },
      'application/json'
    );
    if (response) {
      setIsload(false);
    }
    setLoginLogs(response?.data);
    setPageCount(response.page);
    setNext(1);
  };

  const changePage = async ({ selected }) => {
    const newPage = selected + 1;

    try {
      setIsload(true);
      const response = await postAsync(
        `EP_UserAuthentication/EPUserLoginLogsGetByID?page=${newPage}&pageSize=${pageOptions.pageSize}`,
        { epUserID: epUserID },
        'application/json',
      );
      if (response) {
        setIsload(false);
      }
      setLoginLogs(response?.data);
      setPageCount(response.page);
      setNext(selected + 1);
    } catch (err) {
      console.log(err);
      toast.error(`${t('msg_errorDueto')}: ${err.message}`);
    }
  };

  return (
    <div className="py-4">
      <LogsTable
        isAdmin={false}
        loginLogs={loginLogs}
        changePage={changePage}
        setPageOptions={setPageOptions}
        next={next}
        pageOptions={pageOptions}
        setPageCount={setPageCount}
        pageCount={pageCount}
        isload={isload}
      />
    </div>
  );
};

export default UserLogs;
